import HorizontalFill from "@entrilia/shared/components/HorizontalFill.tsx";
import { MenuItemStyled } from "@entrilia/shared/components/MenuItemStyled.tsx";
import { Grid, Select, Typography } from "@mui/material";
import { useMemo } from "react";
import { BiAggregation } from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import { findAggregationTypes } from "../../../../../utilities/aggregationHelper.ts";
import { useSupportedAggregationsContext } from "../../../../viewer/common/context/SupportedAggregationsContext.ts";
import type { DimensionAggregationProps } from "./DimensionAggregation.tsx";

interface Props extends Pick<DimensionAggregationProps, "field"> {
  onChangeAggregation: (value: BiAggregation | undefined) => void;
  readonly: boolean;
}
const AggregationType = ({ field, onChangeAggregation, readonly }: Props) => {
  const { getSupportedAggregationTypes } = useSupportedAggregationsContext();
  const availableAggregations = useMemo(() => {
    const aggregations = getSupportedAggregationTypes(field);
    return findAggregationTypes(aggregations);
  }, [field, getSupportedAggregationTypes]);

  return (
    <Grid container sx={{ alignItems: "center" }}>
      <Typography>Aggregation</Typography>
      <HorizontalFill />
      <Select
        value={field.config.aggregation || BiAggregation.None}
        sx={{
          width: 208,
          ".MuiSelect-select": {
            py: 0.7,
          },
        }}
        disabled={readonly}
      >
        {availableAggregations.map((item) => (
          <MenuItemStyled
            key={item.value}
            value={item.value}
            selected={item.value === field.config.aggregation}
            onClick={() => onChangeAggregation(item.value)}
            disabled={readonly}
          >
            <Typography variant="caption">{item.text}</Typography>
          </MenuItemStyled>
        ))}
      </Select>
    </Grid>
  );
};

export default AggregationType;
